import mitt from "mitt";

export const Eventbus = mitt();
